import { connect } from 'react-redux';

import { getCurrencyCode } from 'src/store/view/selectors';
import {
  getPlainFilters,
  getAllFiltersDisabled,
} from '../../domain/state/filters/selectors';
import { isFiltersHidden } from '../../domain/state/view/selectors';
import { hasSuggestResults } from '../../domain/state/filters/status_selectors';
import { getInitialTouristsCount } from '../../domain/state/searcher/selectors';
import { modifierStylesSelector } from '../../domain/state/modifier/selectors';

import {
  changeFilterAction,
  clearFilterAction,
} from '../../domain/state/filters/actions';

import { FilterContainer } from './FilterContainer';

const mapStateToProps = (state) => ({
  filters: getPlainFilters(state),
  touristsCount: getInitialTouristsCount(state),
  hasAwaitNewResults: hasSuggestResults(state),
  sidebarIsHidden: isFiltersHidden(state),
  disabled: getAllFiltersDisabled(state),
  modifierStyles: modifierStylesSelector(state),
  currencyCode: getCurrencyCode(state),
});

const mapDispatchToProps = (dispatch) => ({
  changeFilter: (payload) => {
    dispatch(changeFilterAction(payload));
  },
  clearFilter: (payload) => dispatch(clearFilterAction(payload)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(FilterContainer);
